const getLocation = () =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          Long: position.coords.longitude,
          Lat: position.coords.latitude,
        });
      },
      (error) => {
        console.log(error.message);
        let errorMessage = "An unknown error occurred.";
        if (error.code === 1) {
          errorMessage = "Permission denied. Please allow location access.";
        } else if (error.code === 2) {
          errorMessage = "Position unavailable. Try again later.";
        } else if (error.code === 3) {
          errorMessage = "Timeout. Please try again.";
        }

        console.error(errorMessage);
        reject(errorMessage);
        resolve({ Long: 0, Lat: 0 });
      },
      {
        enableHighAccuracy: false, //Set to false to use Wi-Fi/IP-based location
        timeout: 30000,
        maximumAge: 60000, //Cached location
      }
    );
  });

export default getLocation;
